import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import ServiceApi from "../../../services/ServiceApi";
import Cookies from "js-cookie";
import { changeLang } from "../../../actions/langAction";
import { setDynamic } from "../../../actions/dynamicAction";
/* component */
import Layout from "../../../components/layout_operation";
import {
  Header,
  Mainjobtype,
  Problemdetail,
  Employment,
  Startstation,
  Stopstation,
  Effectsite,
} from "../../../components/uih/addjob";
import Jobdetail from "../../../components/uih/editjob/jobdetail/JobDetaiEdit";
import { notification, Spin } from "antd";
import moment from "moment";
import { Helmet } from "react-helmet";

function Copyjob(props) {
  const {
    company_id: CompanyId,
    operator_id: OperatorId,
    project_id: ProjectId,
    job_id,
  } = useParams();
  /* state */
  const [FormData, setFormData] = useState({
    job_type_id: "",
    job_sub_type_id: "",
    soid: "",
    saptype: "",
    workcenter: "",
    subcenter: "",
    alarmtype: "",
    alarmdata: "",
    startdate: "",
    madate: "",
    informby: Cookies.get("username"),
    jobdetail: "",
    remark: "",
    slalevel: "",
    sla_time_day: "",
    sla_time_hour: "",
    sla_time_min: "",
    priority: "",
    employment: "",
    employmenttype: "",
    employmentreson: "",
    startsiteid: "",
    startsitegrade: "",
    startsitename: "",
    startsitelatitude: "",
    startsitelongtitude: "",
    stopsiteid: "",
    stopsitegrade: "",
    stopsitename: "",
    stoptsitelatitude: "",
    stoptsitelongtitude: "",
    numofeffectsite: "",
    effectsiteid: "",
  });
  const [areacode, setareacode] = useState("");
  const { factUpdate, LangTranslate } = props;
  // const [factUpdate, setfactUpdate] = useState(false);
  // const [LangTranslate, setLangTranslate] = useState([]);
  const locale = Cookies.get("locale");
  const [JobCategory, setJobCategory] = useState(1);
  const [JobTypeId, setJobTypeId] = useState(null);
  const [JobCatSelect, setJobCatSelect] = useState([]);
  const [Sla, setSla] = useState([]);
  const [Slatime, setSlatime] = useState({
    sla_time_day: "",
    sla_time_hour: "",
    sla_time_min: "",
  });
  const [submitStatus, setsubmitStatus] = useState(false);
  const [Spinnig, setSpinnig] = useState(true);
  // const [workflowJob, setworkflowJob] = useState([]);
  /* callapi */
  useEffect(() => {
    async function fetchData() {
      // ServiceApi.post("master_language_detail_get", {
      //   company_id: CompanyId,
      //   page_id: 1,
      // })
      //   .then((response) => {
      //     setLangTranslate(
      //       JSON.parse(
      //         response.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
      //       )
      //     );
      //     setfactUpdate(true);
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //   });
      ServiceApi.post("job_detail/get_job_detail", {
        job_id: job_id,
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
      })
        .then((res) => {
          const data = res.data.data.job_detail[0];
          ServiceApi.post("getButtonDetailWeb", {
            ActionID: 1,
            CompanyID: CompanyId,
            JobTypeID: data.job_type_id,
            MainProcessID: data.main_process_id,
            ProjectID: ProjectId,
            SubProcessID: data.subprocessid,
            UserName: Cookies.get("username"),
            Version: 1,
            WF_ID: 0,
            operator_id: OperatorId,
          })
            .then((res) => {
              // setworkflowJob(res.data.return_nextWorkFlow);
              const workflow = res.data.return_nextWorkFlow;
              function checkcanEdit() {
                let canEdit = false;
                if (workflow && workflow.length > 0) {
                  workflow.map((data) => {
                    if (data.next_main_action_id === 25) {
                      canEdit = true;
                    }
                  });
                }
                return canEdit;
              }
              if (!checkcanEdit()) {
                window.location.assign("/MaxiOperation/ma_list");
              }
            })
            .catch((e) => {
              console.log(e);
            });
          setFormData({
            job_cat_id: data.job_category_id,
            job_no: data.job_no,
            job_id: data.job_id,
            job_type_id: data.job_type_id,
            saptype: data.sap_type_id,
            workcenter: data.work_center_id,
            alarmtype: data.alarm_type_id,
            priority: data.priority_id,
            employment: data.employment_flag,
            employmenttype: data.employment_type_flag,
            employmentreson: data.employment_remark,
            numofeffectsite: data.site_effect_Number,
            effectsiteid: data.site_code_list,
          });
          ServiceApi.post("job_detail/get_job_fulldetail", {
            company_id: CompanyId,
            operator_id: OperatorId,
            project_id: ProjectId,
            job_id: job_id,
            job_progress_id: data.job_progress_id,
          }).then((res) => {
            const SiteData = res.data.data.result_site_detail;
            const DetailData = res.data.data.result_job_detail[0];
            SiteData.map((data) => {
              if (data.job_site_typeId === 1) {
                setFormData((FormData) => ({
                  ...FormData,
                  startjob_site_id: data.job_site_id,
                  startsiteid: data.job_site_code,
                  startsitegrade: data.job_site_grade,
                  startsitename: data.job_site_name,
                  startsitelatitude: Number(data.location_lat),
                  startsitelongtitude: Number(data.location_lon),
                }));
              } else {
                setFormData((FormData) => ({
                  ...FormData,
                  stopjob_site_id: data.job_site_id,
                  stopsiteid: data.job_site_code,
                  stopsitegrade: data.job_site_grade,
                  stopsitename: data.job_site_name,
                  stoptsitelatitude: Number(data.location_lat) || 0,
                  stoptsitelongtitude: Number(data.location_lon) || 0,
                }));
              }
            });
            setFormData((Form) => ({
              ...Form,
              jobdetail: DetailData.problem_detail,
              sla_time_day: DetailData.total_days,
              sla_time_hour: DetailData.total_hour,
              sla_time_min: DetailData.total_min,
              job_sub_type_id: DetailData.job_sub_type_id,
              soid: DetailData.so_id,
              sap_id: DetailData.sap_id,
              subcenter: DetailData.sub_center_code,
              alarm_data: DetailData.alarm_data,
              startdate: DetailData.first_start_date,
              remark: DetailData.inform_remark,
              madate: DetailData.emp_inform_date,
              //  informby: DetailData.emp_name,
              employmentreson: DetailData.employment_remark,
            }));
            setSlatime({
              sla_time_day: DetailData.total_days || `-`,
              sla_time_hour: DetailData.total_hour || `-`,
              sla_time_min: DetailData.total_min || `-`,
            });
          });
        })
        .catch((e) => {
          console.log(e);
        });
      setTimeout(() => {
        setSpinnig(false);
      }, 3000);
    }
    fetchData();
  }, [job_id]);
  /* function */
  function changeValue(e) {
    const { name, value } = e.target;
    setFormData((FormData) => ({
      ...FormData,
      [name]: value,
    }));
  }
  function handleSelectValue(type, value, key) {
    if (type === "slalevel") {
      console.log(key);
      let indexSelected = Number(key.key);
      let selectvalue = Number(key.value);
      setFormData((FormData) => ({
        ...FormData,
        [type]: selectvalue,
      }));
      setSlatime({
        sla_time_day: Sla[indexSelected].sla_time_day || 0,
        sla_time_hour: Sla[indexSelected].sla_time_hour || 0,
        sla_time_min: Sla[indexSelected].sla_time_min || 0,
      });
      setFormData((FormData) => ({
        ...FormData,
        sla_time_day: Sla[indexSelected].sla_time_day || 0,
        sla_time_hour: Sla[indexSelected].sla_time_hour || 0,
        sla_time_min: Sla[indexSelected].sla_time_min || 0,
      }));
    } else if (type === "workcenter") {
      let areaCodeM = String(key.key.split("_")[4]);
      setFormData((FormData) => ({
        ...FormData,
        [type]: value,
      }));
      setareacode(areaCodeM);
    } else {
      setFormData((FormData) => ({
        ...FormData,
        [type]: value,
      }));
    }
  }
  function handleDatePicker(value, dateString) {
    setFormData((FormData) => ({
      ...FormData,
      startdate: dateString,
    }));
  }
  function onNumValueChange(value) {
    setFormData((FormData) => ({
      ...FormData,
      numofeffectsite: value,
    }));
  }
  const onSummit = () => {
    let CanSave = true;
    setsubmitStatus(true);
    for (let x in FormData) {
      if (FormData[x] === "" && CanSave) {
        CanSave = false;
      }
    }

    if (
      JobCategory !== null &&
      JobTypeId !== null &&
      FormData.job_sub_type_id !== "" &&
      FormData.startdate !== "" &&
      FormData.workcenter !== ""
    ) {
      let setData = null;
      ServiceApi.post("getButtonDetailWeb", {
        WF_ID: 0,
        CompanyID: CompanyId,
        ProjectID: ProjectId,
        JobTypeID: JobTypeId,
        Version: 1,
        MainProcessID: "0",
        SubProcessID: "-1",
        ActionID: 1,
        UserName: Cookies.get("username"),
        operator_id: OperatorId,
      }).then((res) => {
        if (res.data.return_nextWorkFlow[0]) {
          setData = {
            wfData: [
              {
                ...res.data.return_nextWorkFlow[0],
              },
            ],
            job_no: "",
            //job_id: FormData.job_id,
            //sap_id: FormData.sap_id,
            company_id: CompanyId,
            operator_id: OperatorId,
            project_id: ProjectId,
            job_category_id: JobCategory,
            job_type_id: JobTypeId,
            first_start_date: moment(FormData.startdate).format(
              "YYYY-MM-DD HH:mm"
            ),
            inform_name: FormData.informby,
            jobSiteList: [
              {
                job_site_id: 0, //FormData.startjob_site_id,
                job_site_typeId: 1,
                job_site_code: FormData.startsiteid,
                job_site_grade: FormData.startsitegrade,
                job_site_name: FormData.startsitename,
                location_lat: Number(FormData.startsitelatitude) || 0,
                location_lon: Number(FormData.startsitelongtitude) || 0,
              },
              {
                job_site_id: 0, //FormData.stopjob_site_id,
                job_site_typeId: 2,
                job_site_code: FormData.stopsiteid,
                job_site_grade: FormData.stopsitegrade,
                job_site_name: FormData.stopsitename,
                location_lat: Number(FormData.stoptsitelatitude) || 0,
                location_lon: Number(FormData.stoptsitelongtitude) || 0,
              },
            ],

            job_sub_type_id: FormData.job_sub_type_id,
            multiple_asset_flag: "0",
            asset_id: "0",
            asset_code: "0",
            area_id: "0",
            sub_area_id: "0",
            location_lat: "0",
            location_lon: "0",
            location_name: "",
            emp_inform_id: "1",
            inform_detail: " ",
            inform_remark: FormData.remark,
            priority_level: "0",
            is_active: "1",
            job_status: "0",
            last_job_progress_id: "0",
            last_assign_date: "2020-08-12",
            last_assign_type: "",
            last_person_id: "",
            last_job_remark: "",
            create_method: "",
            create_date: "",
            update_date: "",
            update_by: "",
            delete_date: "",
            delete_by: "",
            trans_flag: "",
            total_assign: "",
            total_amount: "",
            total_vat: "",
            total_amount_bf_vat: "0",
            finish_date: "",
            approved_status: "0",
            approved_by: "",
            approved_remark: "",
            use_material: "",
            sla_pass: "",
            picture_location: "",
            picture_path: "",
            ma_period_id: "",
            service_type_level_id: "0",
            job_point: "0",
            form_id: "0",
            data_dynamic: "",
            interface_id: "0",
            interface_sub_id: "0",
            interface_type: "0",
            interface_attrib1: "0",
            interface_attrib2: "0",
            interface_attrib3: "0",
            priority_id: FormData.priority,
            alarm_data: FormData.alarmdata,
            alarm_type_id: FormData.alarmtype,
            create_by: Cookies.get("username"),
            emp_ma_date: moment(FormData.startdate).format("YYYY-MM-DD HH:mm"),
            employment_flag: FormData.employment,
            employment_remark: FormData.employmentreson,
            employment_type_flag: FormData.employmenttype,
            problem_detail: FormData.jobdetail,
            result_detail: "",
            site_code_list: FormData.effectsiteid,
            site_effect_Number: FormData.numofeffectsite,
            job_sla_id: FormData.slalevel,
            sla_level_id: "0",
            so_id: FormData.soid,
            sub_center_code: FormData.subcenter,
            total_days: FormData.sla_time_day,
            total_hour: FormData.sla_time_hour,
            total_min: FormData.sla_time_min,
            work_center_id: FormData.workcenter,
            sap_type_id: FormData.saptype,
          };
        } else {
          errorNotificationCannot();
          setsubmitStatus(false);
        }
        if (setData.wfData[0].wf_id === null) {
          errorNotificationCannot();
          setsubmitStatus(false);
        } else {
          ServiceApi.post("job_detail/insert_oper_job_trs", setData)
            .then((res) => {
              if (res.data.result.code === "P") {
                SuccessNotification();
                setData = null;
                setTimeout(() => {
                  window.location.assign("/MaxiOperation/ma_list");
                  setsubmitStatus(false);
                }, 1000);
              } else if (res.data.result.code === "F") {
                errorResultNotify(res.data.result?.showText);
                setsubmitStatus(false);
              }
            })
            .catch((e) => {
              console.log(e);
              setsubmitStatus(false);
            });
        }
      });
    } else {
      errorNotification();
      setsubmitStatus(false);
    }
  };
  function errorResultNotify(msg) {
    const args = {
      message: "Error",
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification.warning(args);
  }
  function errorNotification() {
    const args = {
      message: "ผิดพลาด",
      description: "กรุณาเลือก Job Catrgory และ Job Type",
      duration: 5,
      className: "font-thai-b",
    };
    notification.warning(args);
  }
  function errorNotificationCannot() {
    const args = {
      message: "ผิดพลาด",
      description: "คุณไม่มีสิทธ์ในการใช้งาน",
      duration: 5,
      className: "font-thai-b",
    };
    notification.warning(args);
  }
  function SuccessNotification() {
    const args = {
      message: "สำเร็จ",
      description: "ทำสำเนางานเรียบร้อยแล้ว",
      duration: 5,
      className: "font-thai-b",
    };
    notification.success(args);
  }
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>MaxiOperation - Copy Job</title>
      </Helmet>
      <Layout></Layout>
      <Header
        title={`Edit Job Maintenance`}
        preventPage={`Ma List`}
        currentPage={`Edit Job Maintenance`}
      ></Header>
      <Spin spinning={Spinnig} delay={500}>
        <Mainjobtype></Mainjobtype>
        {!Spinnig ? (
          <>
            <div className="d-flex justify-content-center">
              <Jobdetail
                CompanyId={CompanyId}
                OperatorId={OperatorId}
                ProjectId={ProjectId}
                title={factUpdate ? LangTranslate[locale]["job_detail"] : null}
                iscopy={true}
                formdata={FormData}
                setformdata={setFormData}
                valuechange={changeValue}
                selectchange={handleSelectValue}
                language={LangTranslate}
                factupdate={factUpdate}
                updatejobcategory={setJobCategory}
                updatejobtype={setJobTypeId}
                selectjobcat={setJobCatSelect}
                jobcatselect={JobCatSelect}
                updatesla={setSla}
                sla={Sla}
                slatime={Slatime}
              ></Jobdetail>
              <Startstation
                title={
                  factUpdate ? LangTranslate[locale]["start_station"] : null
                }
                formdata={FormData}
                setformdata={setFormData}
                valuechange={changeValue}
                language={LangTranslate}
                factupdate={factUpdate}
                latitude={FormData.startsitelatitude}
                longtitude={FormData.startsitelongtitude}
                areacode={areacode}
              ></Startstation>
            </div>
            <div className="d-flex justify-content-center">
              <Problemdetail
                title={
                  factUpdate ? LangTranslate[locale]["problem_detail"] : null
                }
                formdata={FormData}
                valuechange={changeValue}
                selectchange={handleSelectValue}
                datepicker={handleDatePicker}
                language={LangTranslate}
                factupdate={factUpdate}
                jobcategory={JobCategory}
                jobtypeid={JobTypeId}
                jobcatselect={JobCatSelect}
                sla={Sla}
                slatime={Slatime}
              ></Problemdetail>
              <Stopstation
                title={
                  factUpdate ? LangTranslate[locale]["stop_station"] : null
                }
                formdata={FormData}
                setformdata={setFormData}
                valuechange={changeValue}
                language={LangTranslate}
                factupdate={factUpdate}
                latitude={FormData.stoptsitelatitude}
                longtitude={FormData.stoptsitelongtitude}
                areacode={areacode}
              ></Stopstation>
            </div>
            <div className="d-flex justify-content-center">
              <Employment
                title={factUpdate ? LangTranslate[locale]["employment"] : null}
                formdata={FormData}
                valuechange={changeValue}
                language={LangTranslate}
                factupdate={factUpdate}
              ></Employment>
              <Effectsite
                title={
                  factUpdate ? LangTranslate[locale]["effected_site"] : null
                }
                formdata={FormData}
                valuechange={changeValue}
                numberchange={onNumValueChange}
                language={LangTranslate}
                factupdate={factUpdate}
              ></Effectsite>
            </div>
            <div className="d-flex justify-content-center pb-5 mt-5">
              {submitStatus ? (
                <button type="button" disabled className="btnbrows">
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </button>
              ) : (
                <button type="button" className="btnbrows" onClick={onSummit}>
                  <span className="font-thai-b fs-22">
                    {factUpdate ? LangTranslate[locale]["submit"] : `Submit`}
                  </span>
                </button>
              )}
            </div>
          </>
        ) : null}
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
  LangTranslate: state.masterLang.masterLang,
  factUpdate: state.masterLang.factUpdate,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(Copyjob);
